import { useMutation, gql } from '@apollo/client'
import { isObject } from 'lodash'

export const VALID_IMAGES = 'image/png, image/jpg, image/jpeg'

const CREATE_PRESIGNED_URL_FOR_FILE_UPLOAD = gql`
  mutation CreatePresignedUrlForFileUpload($input: CreatePresignedUrlForFileUploadInput!) {
    createPresignedUrlForFileUpload(input: $input) {
      url
      path
    }
  }
`

type PushFileToS3Fn = (file: File) => Promise<string>

export function usePushFileToS3(): PushFileToS3Fn {
  const [createPresignedUrlForFileUpload] = useMutation(CREATE_PRESIGNED_URL_FOR_FILE_UPLOAD)

  const pushFileToS3 = async (file: File): Promise<string> => {
    const { data } = await createPresignedUrlForFileUpload({
      variables: {
        input: {
          name: file.name
        }
      }
    })

    const myHeaders = new Headers({ 'Content-Type': 'image/*' })
    await fetch(data.createPresignedUrlForFileUpload.url, {
      method: 'PUT',
      headers: myHeaders,
      body: file
    })
    return data.createPresignedUrlForFileUpload.path
  }

  return pushFileToS3
}

export interface IDocument {
  name?: string
  file?: File | ''
  path?: string
  id?: string
}

export const getFileNameWithoutExtension = (file: File | string): string => {
  const fileName = getFileName(file)
  const fileNameSplitted = fileName.split('.')
  fileNameSplitted.pop()
  return fileNameSplitted.join('.')
}

export const getFileName = (file: File | string): string => {
  if (isObject(file)) {
    return decodeURIComponent(file.name)
  }

  const filePathSplitted = file.split('?')[0].split('/')
  return decodeURIComponent(filePathSplitted.at(-1) || '')
}
